import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Pubblicita from "../components/Pubblicita";
import GrowthStats from "../components/GrowthStats";
import Prizes from "../components/Prizes";
import SideLeagues from "../components/SideLeagues";
import Rules from "../components/Rules";
import Founders from "../components/Founders";
import Rankings from "../components/Rankings";
import Sponsors from "../components/Sponsors";
import Trailer from "../components/Trailer";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import { api } from "../lib/config";

export default function HomePage() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings/public").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="home-page">
      <Navbar />
      <Hero settings={settings} />
      <Pubblicita />
      <GrowthStats />
      <Prizes />
      <SideLeagues />
      <Rules />
      <Founders />
      <Rankings />
      <Sponsors />
      <Trailer />
      <Contact />
      <Footer />
    </div>
  );
}
